import { all, takeLatest, call } from 'redux-saga/effects'
import getItems from 'services/item'
import fetchData from '../helpers/fetchData'
import actions from './actions'

function* fetchItems({ payload }) {
  const service = () => getItems(payload)
  yield call(fetchData, actions.itemsApiName, service)
}

export default function* rootSaga() {
  yield all([takeLatest(actions.requestItems, fetchItems)])
}
